import React, { useContext } from 'react';
import styled from 'styled-components';
import type { VariantPickerModel } from 'autogen/swagger/all';
import ActiveSectionContext from '../shared/context/activeSection';
import VerticalList from './VerticalList';

// #region Styles
const Wrapper = styled.div``;

// #endregion Styles

type VerticalSelectionProps = Pick<VariantPickerModel, 'sections' | 'price'>;

export default function VerticalSelection({ sections, price }: VerticalSelectionProps) {
    const { activeSectionIndex } = useContext(ActiveSectionContext);

    return (
        <Wrapper>
            {sections.map(({ variants }, index) => {
                if (index <= activeSectionIndex) {
                    return (
                        // eslint-disable-next-line react/no-array-index-key
                        <VerticalList variants={variants} price={price} key={index} sectionIndex={index} />
                    );
                }
            })}
        </Wrapper>
    );
}
